import type LatLng from './latLng'
import LatLngBounds from './latLngBounds'

const twoPi = Math.PI * 2
const circleSpiralSwitchover = 9
const circleFootSeparation = 56 // related to circumference of circle
const spiralFootSeparation = 56 // related to size of spiral (experiment!)
const spiralLengthStart = 56 // ditto
const spiralLengthFactor = 4 // ditto

type IteratorFn = (index: number) => any
type ItemIteratorFn = (item: any, index: number) => any

/* eslint-disable */
function eachFn(array: any[], iterator: ItemIteratorFn): [] | void {
  var i = 0
  if (!array || !array.length) {
    return []
  }
  for (i = 0; i < array.length; i++) {
    iterator(array[i], i)
  }
}

function eachTimesFn(count: number, iterator: IteratorFn): [] | void {
  if (!count) {
    return []
  }
  for (var i = 0; i < count; i++) {
    iterator(i)
  }
}

function mapFn(array: any[], iterator: ItemIteratorFn): any[] {
  var result: any[] = []
  eachFn(array, function (item, i) {
    result.push(iterator(item, i))
  })
  return result
}

function mapTimesFn(count: number, iterator: IteratorFn): any[] {
  var result: any[] = []
  eachTimesFn(count, function (i) {
    result.push(iterator(i))
  })
  return result
}

const util = {
  each: eachFn,
  map: mapFn,
  mapTimes: mapTimesFn,
  eachTimes: eachTimesFn,
}
/* eslint-enable */

export function generateSpiralParams(count: number) {
  let legLength = spiralLengthStart
  let angle = 0
  return util.mapTimes(count, (index) => {
    angle += spiralFootSeparation / legLength + index * 0.0005
    const pt = {
      x: legLength * Math.cos(angle),
      y: legLength * Math.sin(angle),
    }
    legLength += (twoPi * spiralLengthFactor) / angle
    return pt
  })
}

export function generateCircleParams(count: number) {
  const circumference = circleFootSeparation * (2 + count)
  const legLength = circumference / twoPi // = radius from circumference
  const angleStep = twoPi / count

  return util.mapTimes(count, (index) => {
    const angle = index * angleStep
    return {
      x: legLength * Math.cos(angle),
      y: legLength * Math.sin(angle),
    }
  })
}

export function generateSpiderParams(count: number) {
  if (count >= circleSpiralSwitchover) {
    return generateSpiralParams(count)
  }
  return generateCircleParams(count)
}

export const boundsToLatLngArray = (bounds: string[]) =>
  bounds
    .map((corner) => corner.split(','))
    .map(([lat, lng]) => [parseFloat(lat), parseFloat(lng)])
    .map(([lat, lng]) => ({ lat, lng }))

export const centerFromBounds = ({
  ne,
  sw,
}: {
  ne: [number, number]
  sw: [number, number]
}): [number, number] => {
  let center

  if (!ne || !sw) {
    return center
  }

  const bounds = new LatLngBounds(sw, ne)
  const { lat, lng } = bounds.getCenter()

  if (lat && lng) {
    center = [lat, lng] as [number, number]
  }

  return center
}

export interface Bounds {
  nw: LatLng
  ne: LatLng
  sw: LatLng
  se: LatLng
}

// Re-exported from ./boundsToFloat for callers that already pull this
// from the mapUtils barrel. The canonical definition lives in
// ./boundsToFloat.ts so consumers outside this directory can avoid
// dragging google-map-react along with them.
export { boundsToFloat } from './boundsToFloat'
